import {Flex} from '@sanity/ui'

import Browser from '../Browser'

const Tool = () => {
  return (
    <Flex direction="column" height="fill" flex={1}>
      <Browser />
    </Flex>
  )
}

export default Tool
